'use client'
import { toast } from 'sonner'

interface ErrorList {
    error_code: string
    message: string
}

export const handleError = (result: ApiResponse, successMessage?: string, errorList?: ErrorList[]) => {
    if (result.success) {
        toast.success(successMessage || result.message || result.data?.message || 'Success!')
    } else {
        // Prefer human-readable result.message; fall back to result.error (e.g. error code)
        const errorMessage = result.message || result.error

        if (errorList) {
            const error = errorList.find(e => e.error_code === (result.error_code ?? result.error))
            toast.error(error?.message || errorMessage || 'An unexpected error occurred.')
        } else {
            toast.error(errorMessage || 'An unexpected error occurred.')
        }
    }
}
